import Vue from 'vue'
import Confirmation from './components/Confirmation'
import Prompt from './components/Prompt'
import Notifications from './components/Notifications'
import VeeValidate, {Validator} from 'vee-validate'
import Permission from './components/Permission'
import dateFormatter from './services/DateFormatter'
import dateValidator from './services/DateValidator'
import BootstrapVue from "bootstrap-vue"
import i18n from './services/i18n'
import gateway from './services/gateway'
import SubmitButton from './components/SubmitButton'

export default {
  install() {
    Vue.config.productionTip = false
    Vue.use(BootstrapVue)
    Vue.use(VeeValidate, {i18n: i18n})
    Vue.use(Notifications)
    Vue.use(Confirmation)
    Vue.use(Prompt)
    Vue.use(gateway)
    Vue.component('permission', Permission)
    Vue.component('SubmitButton', SubmitButton)
    Vue.filter('amountWithCurrency', value => (typeof value === 'number') ? value.toFixed(2) + '\xa0€' : '')
    Vue.filter('amount', value => (typeof value === 'number') ? value.toFixed(2) : '')
    Vue.filter('formatVatRate', value => Number(value))
    Vue.filter('formatDate', value => dateFormatter.formatDate(value))
    Vue.filter('formatDateTime', value => dateFormatter.formatDateTime(value))
    Validator.extend('minDays', dateValidator.minDays);
    Validator.extend('maxDays', dateValidator.maxDays);
  }
}
